import { render } from "./SimilarJobs.vue?vue&type=template&id=1c4a8118&scoped=true&ts=true"
import script from "./SimilarJobs.vue?vue&type=script&lang=ts"
export * from "./SimilarJobs.vue?vue&type=script&lang=ts"

import "./SimilarJobs.vue?vue&type=style&index=0&id=1c4a8118&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4a8118"]])

export default __exports__